import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStockbank,
  processOrder,
} from "../../redux/orders/actions/orders.actions";
import styled from "./Instruction.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { constructOrderDate } from "../../helper/DateFormatter";
import { SyncOutlined } from "@ant-design/icons";

const StockProducts = ({
  name,
  address,
  tym,
}) => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { labxOrders, stockbankProducts } = useSelector(
    (state) => state.orderReducer
  );

  // console.log("stockbankProducts", stockbankProducts)

  let nerve = labxOrders?.nerve;
  let coop = labxOrders?.coop;

  // console.log("nerve",nerve)
 

  useEffect(() => {
    dispatch(fetchStockbank(id));
  }, [dispatch, id]);

  const getOrderFromID = () => {
    let order;

    let match = nerve?.find((o) => o.order_id === id);
    if (match) {
      order = match;
    }

    return order;
  };

  const getCoopFromID = () => coop?.find((o) => o.order_id === id);

  let detail = getOrderFromID();
  let coopDetail = getCoopFromID();

  const bgColor = () => {
    if (detail?.title === "blood" || coopDetail?.title === "blood") return "#FDE0E0";
    if (detail?.title === "oxygen" || coopDetail?.title === "oxygen") return "#E0EFFD";
    return "#F0FDE0";
  };

  const color = () => {
    if (detail?.title === "blood" || coopDetail?.title === "blood") return "#B70303";
    if (detail?.title === "oxygen" || coopDetail?.title === "oxygen") return "#2457C5";
    return "#78A55A";
  };

  function delay(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  const processHandler = async () => {
    dispatch(
      processOrder({
        title: "stockbank",
        order_by: detail?.order_by || coopDetail?.order_by,
        order_id: detail?.order_id || coopDetail?.order_id,
      })
    );
    setLoading(true);
    await delay(3000);
    setLoading(false);
    //   localStorage.setItem("stockDetails", JSON.stringify())
    navigate(`/processorder/${id}`);
  };

  return (
    <div className="mt-3 mb-5">
      <div className={` d-flex flex-column justify-content-center`}>
        <div className="d-flex justify-content-between mt-3 mb-3">
          <p className={styled.header} style={{ color: color() }}>
            ORDER DETAILS{" | "}
            <span>{`SBO ${id}`}</span>
          </p>
          <p
            className={styled.name}
            style={{
              background: bgColor(),
              color: color(),
              textTransform: "uppercase",
            }}
          >
            {detail?.title || coopDetail?.title}
          </p>
        </div>
        <div style={{ maxHeight: "65vh", overflowY: "scroll" }}>
          <div className={styled.modalContainer2}>
            <p className={styled.title}>item(s)</p>
            <p className={styled.title}>QUANTITY</p>
            <p className={styled.title}>BRAND</p>
          </div>

          <div className={styled.stockContainer}>
            {stockbankProducts?.map((p, index) => (
              <div key={index} className={styled.stock}>
                <p className={styled.title}>{p.products_name}</p>
                <div className={styled.line}></div>
                <p className={styled.title}>{p.quantity}</p>
                <div className={styled.line}></div>
                <p className={styled.title}>{p.brand ? p.brand : "N/A"}</p>
              </div>
            ))}
          </div>
          <div className={`${styled.modalContainer1} mt-4`}>
            <p className={styled.title}>total product count</p>
            <div className={styled.line}></div>
            <p className={styled.content}>{stockbankProducts.length}</p>
          </div>
          <div className={styled.modalContainer1}>
            <p className={styled.title}>hospital name</p>
            <div className={styled.line}></div>
            <p className={styled.content}>{detail?.name || coopDetail?.name}</p>
          </div>
          <div className={styled.modalContainer1}>
            <p className={styled.title}>hospital address</p>
            <div className={styled.line}></div>
            <p className={styled.content}>{detail?.address || coopDetail?.address}</p>
          </div>
          {/* <div className={styled.modalContainer1}>
          <p className={styled.title}>hospital phone number</p>
          <div className={styled.line}></div>
          <p className={styled.content}>{detail?.phone}</p>
        </div> */}

          <div className={styled.modalContainer1}>
            <p className={styled.title}>order time</p>
            <div className={styled.line}></div>
            <p className={styled.content}>{constructOrderDate(detail?.tym || coopDetail?.tym)}</p>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <button
            className={` shadow-none ${styled.actionBtn} ${styled.reject}`}
            style={{ background: color() }}
            onClick={processHandler}
          >
            {loading ? <SyncOutlined spin /> : `PROCESS ORDER`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockProducts;
